import { DirectTradeForm } from "./DirectTradeForm";
import { useOutletContext } from "react-router-dom";

export const DirectSell = () => {
  const { selectedNavlink } = useOutletContext();

  return (
    <div>
      <DirectTradeForm transactionType={{ selectedNavlink }} />
    </div>
  );
};
